import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import DatePicker from '../components/utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
//import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Button, Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import Input from '@material-ui/core/Input';

//actions:
import { getData, createReport } from '../dataLib';
import { openDialog, hideDialog } from '../actions/index';
import { setCentroDia } from '../actions/centro_dia_actions';
//import { get } from 'ol/proj';


const styles = theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    optionForms: {
        margin: '15px 8px',
        minWidth: 120,
    },
    centroSelect: {
        maxWidth: 240
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 10,
    },
    button: {
        margin: '15px 8px',
        padding: '10px',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        width: 150,
    },
    buttonCerrar: {
        padding: '10px',
        margin: '20px 8px 10px',
        width: 100,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: 250,
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    linearSpinner: {
        height: 10,
        width: 480,
        marginTop: 10,
        marginLeft: 10,
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class ReportRegalosEntregados extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            report: {},
            values: {
                monthIni: 1,
                monthEnd: 1,
                yearIni: 2019,
                yearEnd: 2019,
                centroId: this.props.centroDiaSelected.dia !== '' ? this.props.centroDiaSelected.centro.id : 1,
                iniDate: this.props.centroDiaSelected.dia !== '' ? this.props.centroDiaSelected.dia : '2018-04-03',
                endDate: this.props.centroDiaSelected.dia !== '' ? this.props.centroDiaSelected.dia : '2018-04-03',
                wIniDate: this.props.centroDiaSelected.dia !== '' ? this.props.centroDiaSelected.dia : '2018-04-03',
                wEndDate: this.props.centroDiaSelected.dia !== '' ? this.props.centroDiaSelected.dia : '2018-04-03',
                maquinaId: -100,
                modeloId: -100,
                chk1: false,
                chk2: false,
                chk3: false,
                chk4: false,
                chk5: false,
                opt1: '1',
                opt2: '1',
                dw: 1,
                ids: [],
                page: -1
            },
            modelos: [],
            maquinas: [],
            loaded: false,
            pdfLoading: false,
            centroDiaCierre: 1,
        };

        this.reportId = 52;
    };

    componentDidMount() {
        this.getReportDefinition();
        this.getMaquinas(this.state.values.centroId, this.state.values.opt1); // un poco inutil porque inicialmente es la opción fecha que no busca datos
    };

    getReportDefinition = () => {

        getData(
            'NaReport/' + this.reportId,
            (response) => {
                this.setState({ ...this.state, report: response.data, loaded: true })
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching report definition'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    compareDescr = (a, b) => {

        if (a.descr.toLowerCase() < b.descr.toLowerCase())
            return -1;
        if (a.descr.toLowerCase() > b.descr.toLowerCase())
            return 1;
        return 0;

    }

    getMaquinas = (centroId, option) => { //maquines del centro fbp ojo solo las que dan regalos (expendedoras)

        // en función de la opción se cargan clientes, máquinas o artículos
        let llamada = '';
        let mensaje = '';
        switch (option) {
            case '1': // fecha
                return;
            case '2': // Clientes
                llamada = 'DCMovRedemMaqs/ClientesRegalos/' + centroId;
                mensaje = 'clientes';
                break;
            case '3': // Máquina
                llamada = 'VMaquinas/VMaquinasRegalo?centro_id=' + centroId;
                mensaje = 'ubicaciones';
                break;
            case '4': // Artículos de compra
                llamada = 'ArticuloCompraCentros/list/' + centroId;
                mensaje = 'artículos';
                break;
            default: break;
        }
        getData(
            llamada,
            (response) => {
                this.setState({ ...this.state, loaded: true, maquinas: [...response.data].sort(this.compareDescr) })
            },
            () => {
                this.setState({ ...this.state, loaded: true });
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching ' + mensaje,
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    handleValueChange = (event, field) => {

        const newValues = { ...this.state.values, [field]: event.target.value }
        if (field === 'opt1') {
            this.setState({ ...this.state, values: newValues, loaded: event.target.value !== '1' ? false : true });
            this.getMaquinas(this.state.values.centroId, event.target.value);
        }
        else {
            this.setState({ ...this.state, values: newValues });
        }
    };

    handleSelectCentrosValueChange = (event) => {
        var centroSelected = this.props.centros.find(c => c.id === Number(event.target.value));
        if (centroSelected !== undefined) {
            const newValues = { ...this.state.values, centroId: event.target.value };
            this.setState({ ...this.state, values: newValues, centroDiaCierre: centroSelected.iDiaCierre });
            this.getMaquinas(event.target.value, this.state.values.opt1);
            this.props.setCentroDia(centroSelected.id, this.props.centroDiaSelected.dia, false);
        }
    };

    handleCheckboxChange = (event, field) => {
        const newValues = { ...this.state.values, [field]: event.target.checked }
        this.setState({ ...this.state, values: newValues });
    };


    renderIniDateTime = () => {
        if (this.state.report.dateIni) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label={!this.state.report.dateEnd ? "Fecha final" : "Fecha inicial"}
                        value={this.state.values.iniDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                const newValues = {
                                    ...this.state.values,
                                    iniDate: d.toISOString().slice(0, 10),
                                };
                                this.setState({ ...this.state, values: newValues });
                            }
                        }}
                    />
                </FormControl>
            );
        };
    };

    renderEndDateTime = () => {
        if (this.state.report.dateEnd) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label="Fecha final"
                        value={this.state.values.endDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                const newValues = {
                                    ...this.state.values,
                                    endDate: d.toISOString().slice(0, 10),
                                };
                                this.setState({ ...this.state, values: newValues });
                            }
                        }}
                    />
                </FormControl>
            );
        };
    };

    renderSelectCentros = () => {

        const perfil = this.props.userProfile.selectedCentroProfile.iPerfil;

        const centros = [0, 4, 5, 16, 17, 20].includes(perfil) ?
            this.props.centros.filter(c => c.esCasino === this.state.values.chk1 && c.activo === 1)
            : this.props.centros.filter(c => c.id === this.props.userProfile.selectedCentroProfile.centroId);

        if (this.state.report.centroId) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="input-centros">Centro</InputLabel>
                    <Select className={classes.centroSelect}
                        native
                        value={this.state.values.centroId}
                        onChange={(event) => this.handleSelectCentrosValueChange(event)}
                        input={<Input id="input-centros" />}
                        name="centroId"
                    >
                        {centros.map(centro => {
                            return (<option key={'centro_' + centro.id} value={centro.id}>{centro.centro}</option>)
                        })}
                    </Select>
                </FormControl>
            );
        };
    };

    renderSelectMaquinas = () => { //maquines del centro
        if (this.state.report.maquina) {
            const { classes } = this.props;
            return (
                <div hidden={this.state.values.opt1 === '1'}>
                    <FormControl className={classes.formControl}>
                        {/* <InputLabel htmlFor="input-maquina">Maquina</InputLabel> */}
                        <Select
                            native
                            value={this.state.values.maquinaId}
                            onChange={(event) => this.handleValueChange(event, 'maquinaId')}
                            input={<Input id="input-maquina" />}
                            name="maquinaId"
                            disabled={this.state.values.opt1 === '1'}
                        >
                            {this.state.values.opt1 === '3' ? <option key={'maquina_todos'} value={-100}>Todas</option> : ''}

                            {this.state.maquinas.map(maquina => {
                                return (<option key={'maquina_' + maquina.id} value={maquina.id}>{maquina.descr}</option>)
                            })}

                        </Select>
                    </FormControl>
                </div>
            );
        };
    };

    renderOptionList1 = () => {
        return this.state.report.opt1.split(';').map((o, index) => {
            return (
                <FormControlLabel key={index} value={(index + 1).toString()} control={<Radio />} label={o} />
            );
        });

    };

    renderOption1 = () => {
        if (this.state.report.opt1 !== undefined && this.state.report.opt1 !== null) {
            const { classes } = this.props;
            return (
                <FormControl component="fieldset" className={classes.optionForms} variant='outlined'>
                    <RadioGroup
                        aria-label="Option 1"
                        name="opt1"
                        className={classes.group}
                        value={this.state.values.opt1}
                        onChange={(event) => this.handleValueChange(event, 'opt1')}
                    >
                        {this.renderOptionList1()}
                    </RadioGroup>
                </FormControl>
            );
        };
    };


    viewPDF = (reportValues) => {

        const suffix = this.props.hasIdList ? '/IdListReport' : ''

        const win = window.open(process.env.PUBLIC_URL + '/loading_report.html', '_blank');

        let url = '';

        createReport(reportValues, "PDF", this.props.user, suffix)
            .then(response => {
                url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                //window.open(url, '_blank');
                win.location.href = url
            }).catch(error => {
                this.props.openDialog('SimpleMessage', {
                    message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF'
                }, uuidv4(), false, false);
            }).then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });

    }

    downloadPDF = (reportValues) => {

        const suffix = this.props.hasIdList ? '/IdListReport' : ''

        createReport(reportValues, "PDF", this.props.user, suffix)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report_' + reportValues.reportDefinition.descr.replace(/ /gi, "_") + ".pdf");
                document.body.appendChild(link);
                link.click();
            }).catch(error => {
                this.props.openDialog('SimpleMessage', {
                    message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF'
                }, uuidv4(), false, false);
            }).then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });

    };

    downloadExcel = (reportValues) => {

        const suffix = this.props.hasIdList ? '/IdListReport' : ''

        createReport(reportValues, "EXCEL", this.props.user, suffix)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report_' + reportValues.reportDefinition.descr.replace(/ /gi, "_") + ".xls");
                document.body.appendChild(link);
                link.click();
            }).catch(error => {
                this.props.openDialog('SimpleMessage', {
                    message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF'
                }, uuidv4(), false, false);
            }).then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };

    renderDates = () => {
        return (
            <Grid container spacing={16}>
                <Grid item xs={6}>
                    {this.renderIniDateTime()}
                </Grid>
                <Grid item xs={6}>
                    {this.renderEndDateTime()}
                </Grid>
            </Grid>
        );
    };

    handleCentroSelection = (rows) => {

        const newValues = { ...this.state.values, ids: rows.map(i => this.props.centros.filter(c => c.isGroup === false)[i].id) };
        this.setState({ ...this.state, values: newValues, });

    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                {this.state.loaded ?
                    <div>
                        <div>
                            {
                                this.props.isDialog ?
                                    <Typography variant="h6" style={{ margin: '10px 8px' }} color={'primary'}>{this.state.report.descr}</Typography>
                                    : ''
                            }

                            {this.renderSelectCentros()}
                            {this.renderDates()}
                            {this.renderOption1()}
                            {this.renderSelectMaquinas()}

                            <div>
                                {/* <Tooltip title="Ver PDF (permite descarga posterior)" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                                        const reportValues = { reportDefinition: this.state.report, values: this.state.values };
                                        this.setState({ ...this.state, pdfLoading: true });
                                        this.viewPDF(reportValues);
                                    }}>Abrir PDF</Button>
                                </Tooltip>
                                <Tooltip title="Descarga pdf sin visualizar previamente" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                                        const reportValues = { reportDefinition: this.state.report, values: this.state.values };
                                        this.setState({ ...this.state, pdfLoading: true });
                                        this.downloadPDF(reportValues);
                                    }}>Descargar PDF</Button>
                                </Tooltip> */}
                                <Tooltip title="Vista rápida de datos en tabla" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                                            const reportValues = { reportDefinition: this.state.report, values: this.state.values };
                                            this.props.openDialog('ReportDataGrid', {reportValues:reportValues} , 'report-data-grid', false, 'lg');
                                        }}>Tabla rápida</Button>
                                </Tooltip>
                                {/* <Tooltip title="Descarga en hoja excel" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                                        const reportValues = { reportDefinition: this.state.report, values: this.state.values };
                                        this.setState({ ...this.state, pdfLoading: true });
                                        this.downloadExcel(reportValues);
                                    }}>Descargar Excel</Button>
                                </Tooltip> */}
                            </div>

                        </div>
                        {this.state.pdfLoading ?
                            <LinearProgress className={classes.linearSpinner} variant="indeterminate" />
                            : ''}

                        {this.props.isDialog ?
                            <Button className={classes.buttonCerrar} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                            : ''
                        }
                    </div>
                    :
                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>
                }
            </div>
        );
    };

};

ReportRegalosEntregados.propTypes = {
    //state:
    centroDiaSelected: PropTypes.object.isRequired,
    centros: PropTypes.array,
    user: PropTypes.object.isRequired,
    //dispatch:
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //params:
    hasIdList: PropTypes.bool
};

function mapStateToProps(state) {

    return {
        centroDiaSelected: state.centroDiaSelected,
        centros: state.centros.centros,
        user: state.oidc.user,
        userProfile: state.userProfile
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        setCentroDia,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ReportRegalosEntregados));